<template>
  <div class="orders-list-table">
    <el-table :data="dataList" ref="multipleTable" @selection-change="onSelectionChange">
      <template v-for="{ type, prop, label, width, slot, align, fixed } in config">
        <el-table-column :key="prop" :label="label" :type="type" :min-width="width" :align="align"
          v-if="type"></el-table-column>
        <el-table-column :key="prop" :prop="prop" :label="label" :min-width="width" :fixed="fixed" :align="align"
          v-else-if="slot">
          <template slot="header">
            <div v-if="slot === 'userCommission' || slot === 'vipCommission'"
              style="height: 30px; display: flex; justify-content: center">
              <div style="line-height: 30px">{{ label }}</div>
              <div style="margin-top: 5px" v-if="slot === 'vipCommission'">
                <el-tooltip effect="dark" content="该笔订单中服务商最终获得的佣金；（平台佣金+平台利润-用户佣金+扣除保证金）" placement="top">
                  <img src="../../../assets/icon/icon_qipao.png" style="width: 18px; height: 18px; margin-left: 4px" />
                </el-tooltip>
              </div>
              <div style="margin-top: 5px" v-if="slot === 'userCommission'">
                <el-tooltip effect="dark" content="该笔订单中用户获得的佣金；（商品金额*特定的商品佣金）" placement="top">
                  <img src="../../../assets/icon/icon_qipao.png" style="width: 18px; height: 18px; margin-left: 4px" />
                </el-tooltip>
              </div>
            </div>
            <div v-else>{{ label }}</div>
          </template>
          <template slot-scope="scope">
            <template v-if="slot === 'goods' && typeStr === 'logisticsOrder'">
              <!-- z-index 递减 上层 覆盖 下层 -->
              <div class="itemN" :style="{ zIndex: 100 - scope.$index }">
                <div style="display: flex">
                  <div v-if="scope.row.orderNo" style="margin-left: 40px; cursor: pointer"
                    @click="copyInfo(scope.row.orderNo)">
                    订单编号：{{ scope.row.orderNo }}
                  </div>
                  <div class="hint_pr">
                    创建时间：{{ scope.row.createdTime }}
                  </div>
                  <div class="hint_pr">支付时间：{{ scope.row.payTime }}</div>
                  <div class="hint_pr" style="cursor: pointer" @click="copyInfo(scope.row.outTradeNo)">
                    支付单号：{{ scope.row.outTradeNo }}
                  </div>
                  <!-- <div class="hint_pr">
                    订单类型：{{ scope.row.orderTypeLabel }}
                  </div> -->
                  <div class="hint_pr">
                    来源类型：{{ scope.row.originTypeLabel }}
                  </div>
                  <div class="hint_pr">
                    广告ID：{{ scope.row.adAccountId }}
                  </div>
                  <!-- <div
                    v-if="scope.row.applierName"
                    class="hint_pr tooltip"
                    aria-label="点击复制"
                    @click="copyInfo(scope.row, 'service')"
                  >
                    跟进客服：{{ scope.row.applierName }}
                  </div> -->
                </div>
                <div class="hint_pr-operation" style="margin-right: 60px">
                  <template>
                    <label style="color: #2d46ee" @click="
                      toOtherPages(
                        'inflowLogisticsOrderDetail',
                        scope.row,
                        'Details'
                      )
                      ">查看/编辑</label>
                  </template>
                </div>
              </div>
              <div v-if="scope.row.orderDetailList">
                <div class="mesSty" v-for="(item, index) in scope.row.orderDetailList" :key="index">
                  <!-- <img class="imgSty" src="https://dummyimage.com/72x54/FF6600" alt="">-->
                  <el-image :src="item.goodsImg" fit="cover" style="margin-top: 4px"></el-image>
                  <div class="mesFont">
                    <div style="
                        width: 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-left: 8px;
                      ">
                      {{ item.goodsName }}
                    </div>
                    <div style="
                        width: 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-left: 8px;
                        font-size: 13px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 17px;
                        color: #606066;
                      ">
                      规格：{{ item.goodsSkuName }} * {{ item.goodsQuantity }}
                    </div>
                    <!-- <p :title="item.goodsName + '*' + item.goodsQuantity">
                      <span>{{ item.goodsName }}</span>
                    </p>
                    <p>{{ item.goodsSkuName }} * {{ item.goodsQuantity }}</p> -->
                  </div>
                </div>
              </div>
            </template>
            <template v-if="slot === 'no' && typeStr === 'afterOrder'">
              <!-- z-index 递减 上层 覆盖 下层 -->
              <div class="itemN" :style="{ zIndex: 100 - scope.$index }">
                <div style="display: flex">
                  <div v-if="scope.row.orderNo" style="margin-left: 40px">
                    订单编号：{{ scope.row.orderNo }}
                  </div>
                  <div class="hint_pr" v-if="routeObj.name === 'ordersList' ||
                    routeObj.name === 'operatorsOrderList'
                    ">
                    客户：{{ scope.row.userName }}（{{ scope.row.userPhone }}）
                  </div>
                  <div class="hint_pr" v-if="routeObj.name === 'operatorsOrderList'">
                    订单类型：{{ scope.row.orderTypeLabel }}
                  </div>
                  <div class="hint_pr" v-if="routeObj.name === 'operatorsOrderList'">
                    业绩归属人：{{ scope.row.achievementUserName }}
                  </div>
                  <div v-if="scope.row.applierName" class="hint_pr tooltip" aria-label="点击复制"
                    @click="copyInfo(scope.row, 'service')">
                    跟进客服：{{ scope.row.applierName }}
                  </div>
                  <!--<div v-if="scope.row.submitDate" class="hint_pr">{{typeStr==='auditOrder'?'提交时间':'下单时间'}}：{{ scope.row.submitDate }}</div>-->
                  <div v-if="scope.row.createdTime && isShowTime.createdTime" class="hint_pr">
                    {{ typeStr === "operation" ? "提交时间" : "下单时间" }}：{{
                      scope.row.createdTime
                    }}
                  </div>
                  <div v-if="scope.row.submitDate && isShowTime.submitDate" class="hint_pr">
                    提交审核时间：{{
                      scope.row.status == 99 ? "-" : scope.row.submitDate
                    }}
                  </div>
                </div>

                <div class="hint_pr-operation" style="margin-right: 50px">
                  <template>
                    <label style="color: #2d46ee" @click="
                    toOtherPages('afterOrderDetail', scope.row, 'Details')
                      ">查看</label>
                    <label style="color: #2d46ee; margin-left: 10px" @click="apply">审核</label>
                  </template>
                </div>
              </div>
              <div v-if="scope.row.details">111111111</div>
            </template>
            <template v-if="slot === 'user'">
              <p>{{ scope.row.userName }}</p>
              <p>(ID:{{ scope.row.userId }})</p>
              <p>{{ scope.row.userPhone }}</p>
            </template>
            <template v-if="slot === 'postName'">
              <p>{{ scope.row.postName }}</p>
              <p>{{ scope.row.postPhone }}</p>
            </template>
            <template v-if="slot === 'userCommission'">
              <p>{{ Number(scope.row.userCommission).toFixed(2) }}</p>
            </template>
            <template v-if="slot === 'vipCommission'">
              <p>{{ Number(scope.row.vipCommission).toFixed(2) }}</p>
            </template>
            <template v-if="slot === 'order'">
              <p :title="scope.row.statusLabel">
                <i v-bind:class="[
                  { 'danger-bg': scope.row.status == 1 },
                  { 'info-bg': scope.row.status == 7 },
                  {
                    'warning-bg':
                      scope.row.status == 2 ||
                      scope.row.status == 3 ||
                      scope.row.status == 4 ||
                      scope.row.status == 5,
                  },
                  'round',
                  { 'success-bg': scope.row.status === 6 },
                ]"></i>
                {{ scope.row.statusLabel }}
              </p>
            </template>
            <template v-if="slot === 'amount'">
              <p>{{ Number(scope.row.receivableAmount).toFixed(2) }}</p>
              <p>(含快递:{{ Number(scope.row.freightAmount).toFixed(2) }})</p>
              <p>(含优惠:{{ Number(scope.row.discountAmount).toFixed(2) }})</p>
            </template>
            <template v-if="slot === 'goodsAmount'">
              <p>{{ Number(scope.row.goodsAmount).toFixed(2) }}</p>
            </template>

            <template v-if="slot === 'discountAmount'">
              <p>{{ Number(scope.row.discountAmount).toFixed(2) || 0.00 }}</p>
            </template>

            <template v-if="slot === 'operation'">
              <p>操作人：{{ scope.row.closedPersonName }}</p>
              <p>时间：{{ scope.row.closedTime }}</p>
            </template>
          </template>
        </el-table-column>
        <el-table-column :key="prop" :prop="prop" :label="label" :min-width="width" :align="align"
          v-else></el-table-column>
      </template>
    </el-table>
    <el-dialog title="售后申请" :visible.sync="isApply" width="518px" :append-to-body="true">
      <template>
        <div class="info">是否审核通过？</div>
        <div style="margin-top: 18px">
          <el-radio-group v-model="radio">
            <el-radio :label="3">通过</el-radio>
            <el-radio :label="6">驳回</el-radio>
          </el-radio-group>
        </div>
        <div v-if="radio == 3" class="pass">
          确认后，金额<span class="price">￥1000.00</span>将退回买家账户
        </div>
        <div v-if="radio == 6" style="margin-top: 24px; width: 90%; margin-bottom: 24px">
          <div style="display: flex">
            <div style="margin-right: 8px; width: 10%">备注</div>
            <div style="width: 90%">
              <el-input type="textarea" style="width: 100%" placeholder="请输入备注" maxlength="200" show-word-limit rows="5">
              </el-input>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isApply = false">取消</div>
          <div class="info-s" @click="isApply = false">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrdersListTable',
  props: {
    afterSale: {
      type: String,
      default: () => ''
    },
    typeStr: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ' '
    },
    heightStr: {
      type: String,
      default: () => '500px'
    },
    sortObj: { // 排序
      type: Object,
      default: () => {
      }
    },
    config: {
      type: Array,
      default: () => []
    },
    dataList: { // 数据列表
      type: Array,
      default: () => []
    },
    parArrayArr: { // 按钮权限
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      radio: 3,
      isApply: false,
      userInfo: {},
      operationActiveIndex: '1',
      popSty: false,
      isShowCom: {}, // 操作 按钮 组件显示 默认 全为 false
      isShowTime: {
        closedTime: false, // 关闭时间
        createdTime: false, // 下单时间
        finishedTime: false, // 审核时间
        submitDate: false // 提交审核时间
      },
      routeObj: {}
    }
  },
  watch: {
    config: {
      handler(newVal, oldVal) {
        console.log(newVal)
      },
      deep: true
    },
    dataList: {
      handler(newVal, oldVal) {
        // console.log(newVal)
        setTimeout(_ => {
          // this.resetStyle() // 样式调整
        }, 100)
      },
      deep: true
    },
    typeStr(value) {
      // console.log(value)
      this.showCom() // 操作 按钮 组件显示
    },
    // afterSale: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal)
    //   }
    // },
    $route() {
      // this.testFun();
    }
  },
  mounted() {
    // console.log(this.dictionaries.after_sale_reason)
    this.$nextTick(_ => {
      // this.resetDate()
      console.log('afterSale==', this.afterSale)
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.onShowTime()
    })
  },
  created() {
    this.routeObj = this.$route
  },
  methods: {
    copyInfo(val) {
      const that = this

      that.$copyText(val).then(
        function (e) {
          that.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          that.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    apply() {
      this.isApply = true
    },
    onShowTime() {
      const routeName = this.$route.name
      switch (routeName) {
        case 'ordersList': // 客服订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'examinationOrderList': // 审核订单
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleOrdeList': // 售后订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleRecordList': // 售后记录
          break
        default:
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.finishedTime = true // 审核时间
        // console.log('%c默认值！👀', 'color:#fff;font-size:1.2rem;padding:0.8rem 1.6rem;border-radius: 5px;background-color: #3eaf7c;font-family: "Microsoft YaHei",Arial,sans-serif;')
      }
      console.log(routeName, this.isShowTime)
    },
    resetStyle() {
      this.$nextTick(_ => {
        // 获取 所有行
        const elTableRowFirst = document.getElementsByClassName('el-table__row')
        elTableRowFirst.forEach((item, index) => {
          if (index === 0) {
            // 获取  第一行的第二个
            // return console.log(item)
            const elTableCell = item.getElementsByClassName('el-table__cell')[1]
            const elTableCell5 = item.getElementsByClassName('el-table__cell')[5]
            const elTableCelldivCell = elTableCell5.getElementsByClassName('cell')[0]

            const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
            if (!relationOrder) {
              elTableCell.style.paddingTop = '45px'
              elTableCelldivCell.setAttribute('style', '')
              // console.log('没找到关联订单调整 ppadding-top')
            } else {
              elTableCell.setAttribute('style', '')
              elTableCelldivCell.style.marginTop = '30px'
            }
          } else {
            // 获取  其它行的第二个
            // return console.log(item)
            const elTableCell = item.getElementsByClassName('el-table__cell')[1]
            const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
            const mesSty = elTableCell.getElementsByClassName('mesSty')[0]
            if (relationOrder) {

            } else {
              mesSty.setAttribute('style', '')
            }
          }
        })
      })
    },
    // 页面跳转
    toOtherPages(name, parameter, type) {
      // console.log(name, parameter, type)
      // console.log(parameter)
      // return
      let query = {}
      query = { orderNo: parameter.orderNo, orderId: parameter.id, }
      this.$router.push({ name, query })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },


    onSelectionChange(val) { // 多选
      // this.multipleSelection = val;
      // console.log(val)
      this.$emit('tableSelectionChange', val)
    }
  }
}
</script>
<!--<style scoped>-->
<style lang="scss" scoped>
.pass {
  width: 414px;
  height: 36px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 2px;
  line-height: 36px;
  padding-left: 12px;
  margin-top: 24px;
  margin-bottom: 100px;

  .price {
    color: #f63c56;
  }
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.tooltip {
  position: relative;
  /*margin: 50px auto;*/
  /*border: 1px solid;*/
  cursor: pointer;
}

.tooltip[aria-label]:hover:after {
  content: attr(aria-label);
  position: absolute;
  bottom: -38px;
  left: 30%;
  /*border: 1px solid;*/
  width: 80px;
  text-align: center;
  border-radius: 3px;
  padding: 5px;
  color: #ffffff;
  font-size: 12px !important;
  background-color: rgba(0, 0, 0, 0.5);
}

.mesSty:after {
  clear: both;
  display: table;
  content: "";
}

/*圆点*/
.round {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background-color: #0b7df3;
  display: inline-block;
}

.primary-bg {
  background-color: #409eff !important;
}

.success-bg {
  background-color: #12ab62 !important;
}

.warning-bg {
  background-color: #e6a23c !important;
}

.danger-bg {
  background-color: #f56c6c !important;
}

.info-bg {
  background-color: #909399 !important;
}

.el-table {
  overflow: unset;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: #ffffff;
}

::v-deep.el-table th.el-table__cell {
  background-color: #f8f8f8;
}

::v-deep.el-table th.el-table__cell .cell {
  color: #333333;
  font-size: 14px;
}

/deep/ .el-table tr {
  position: relative;
  width: 100%;
}

/deep/ .el-table .el-table__body-wrapper {
  /*padding-top: 40px;*/
  overflow: unset;
}

::v-deep.el-table .el-table__body .el-table__row {
  position: relative !important;
}

::v-deep.el-table .el-table__body .el-table__row:first-child {
  /*background-color: #2D7EDF;*/
}

::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
  position: absolute;
  top: 8px;
  left: 0;
  z-index: 10000;
}

::v-deep.el-table .el-table__body .el-table__row:first-child td:first-child .cell {
  top: 8px;
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(2) {
  position: static !important;
  /*padding: 5px 0;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(1) {
  /*position:relative!important;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell {
  // background-color: #0b7df3;
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row:first-child .el-table__cell:nth-child(2) {
  /*background-color: #0b7df3;*/
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(2) {
  /*background-color: #0b7df3;*/
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}

::v-deep.orders-list-table .el-table .el-table__row:first-child .el-table__cell:nth-child(2) .item {
  /*background-color: #0b7df3;*/
  margin-top: 0;
}

::v-deep.orders-list-table .el-table .el-table__cell:nth-child(2) .item {
  /*background-color: #0b7df3;*/
  margin-top: -44px;
}

.item {
  width: 100%;
  height: 40px;
  background-color: #ebeef5;
  padding: 7px 0 7px 50px;
  position: absolute;
  /*top: 0;*/
  left: 0;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

.itemN {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  background-color: #ebeef5;
  // padding: 7px 0 7px 50px;
  position: absolute;
  top: 0;
  left: 0;
  margin-bottom: 20px;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

::v-deep.el-table .el-table__body .el-table__row:first-child td:nth-child(2) .item {
  top: 0;
  /*background-color: rgba(0,0,0,0.3);*/
}

.item>div {
  float: left;
}

.item div:first-child label:first-child {
  font-size: 14px;
  color: #4168e7;
  line-height: 10px;
  display: block;
}

.item div:first-child label:nth-child(2) {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}

.hint_pr {
  padding-left: 4vh;
  // line-height: 20px;
}

.hint_pr-operation {
  margin-right: 20px;
  float: right !important;
  position: relative;
  z-index: 10;
}

.hint_pr-operation label {
  cursor: pointer;
}

.hint_pr-operation ul {
  display: none;
  position: absolute;
  right: -14px;
  background-color: #f9f9f9;
  min-width: 100px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1000;
  cursor: pointer;
}

.hint_pr-operation:hover ul {
  display: block;
  border-radius: 3px;
}

.hint_pr-operation ul li {
  text-align: center;
  line-height: 30px;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
}

.hint_pr-operation ul li:last-child {
  border-bottom: none;
}

.imgSty {
  width: 80px;
  display: block;
}

.mesSty {
  /*display: flex;*/
  /*align-items: center;*/
  margin-bottom: 8px;
}

.mesSty .el-image {
  width: 64px;
  height: 64px;
  float: left;
}

.mesSty .mesFont {
  float: left;
  width: calc(100% - 100px);
  //text-align: center;
}

.mesSty .mesFont p {
  margin-block-start: 0;
  margin-block-end: 0;
  margin-left: 5px;
  color: #333333;
  /*font-size: 12px;*/
  line-height: 27px;
}

.mesSty .mesFont p:nth-child(1) {
  color: #999999;
  font-size: 12px;
}

.mesSty .mesFont p:nth-child(1) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.iconSty {
  float: right;
  cursor: pointer;
}

@media (min-width: 1500px) {}

@media screen and (max-width: 1500px) {
  .item div:first-child label:first-child {
    font-size: 14px;
    color: #4168e7;
    line-height: 20px;
    display: block;
  }

  .item {
    width: 100%;
    height: 40px;
    background-color: #ebeef5;
    padding: 0px 0 7px 50px;
    position: absolute;
    /*top: 0;*/
    left: 0;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }

  .hint_pr {
    padding-left: 8vh;
    line-height: 20px;
  }

  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -32px;*/
  }
}

@media screen and (max-width: 1200px) {
  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -25px;*/
  }
}

@media (min-width: 768px) {}

.afterSaleAmount {
  margin-top: 40px;
}

.afterSaleStatus {
  margin-top: 50px;
}
</style>
